import { render, staticRenderFns } from "./SectionPartners.vue?vue&type=template&id=26026b1f&scoped=true&"
import script from "./SectionPartners.vue?vue&type=script&lang=js&"
export * from "./SectionPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26026b1f",
  null
  
)

export default component.exports